import { render, staticRenderFns } from "./LegalDocumentsSettings.vue?vue&type=template&id=13cf5684&scoped=true&"
import script from "./LegalDocumentsSettings.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentsSettings.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentsSettings.vue?vue&type=style&index=0&id=13cf5684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cf5684",
  null
  
)

export default component.exports